export const REQUEST_MASTER_DISCOUNT_FILTER = "REQUEST_MASTER_DISCOUNT_FILTER";
export const SET_MASTER_DISCOUNT_FILTER = "SET_MASTER_DISCOUNT_FILTER";
export const ERROR_GET_MASTER_DISCOUNT_FILTER =
  "ERROR_GET_MASTER_DISCOUNT_FILTER";

export const REQUEST_MASTER_DISCOUNT_FILTER_CATEGORIES =
  "REQUEST_MASTER_DISCOUNT_FILTER_CATEGORIES";
export const SET_MASTER_DISCOUNT_FILTER_CATEGORIES =
  "SET_MASTER_DISCOUNT_FILTER_CATEGORIES";
export const ERROR_GET_MASTER_DISCOUNT_FILTER_CATEGORIES =
  "ERROR_GET_MASTER_DISCOUNT_FILTER_CATEGORIES";

export const REQUEST_CREATE_MASTER_DISCOUNT_FILTER =
  "REQUEST_CREATE_MASTER_DISCOUNT_FILTER";
export const SUCCESS_CREATE_MASTER_DISCOUNT_FILTER =
  "SUCCESS_CREATE_MASTER_DISCOUNT_FILTER";
export const ERROR_CREATE_MASTER_DISCOUNT_FILTER =
  "ERROR_CREATE_MASTER_DISCOUNT_FILTER";

export const REQUEST_UPDATE_MASTER_DISCOUNT_FILTER =
  "REQUEST_UPDATE_MASTER_DISCOUNT_FILTER";
export const SUCCESS_UPDATE_MASTER_DISCOUNT_FILTER =
  "SUCCESS_UPDATE_MASTER_DISCOUNT_FILTER";
export const ERROR_UPDATE_MASTER_DISCOUNT_FILTER =
  "ERROR_UPDATE_MASTER_DISCOUNT_FILTER";

export const REQUEST_DELETE_MASTER_DISCOUNT_FILTER =
  "REQUEST_DELETE_MASTER_DISCOUNT_FILTER";
export const SUCCESS_DELETE_MASTER_DISCOUNT_FILTER =
  "SUCCESS_DELETE_MASTER_DISCOUNT_FILTER";
export const ERROR_DELETE_MASTER_DISCOUNT_FILTER =
  "ERROR_DELETE_MASTER_DISCOUNT_FILTER";

export const SET_MESSAGE_MASTER_DISCOUNT_FILTER =
  "SET_MESSAGE_MASTER_DISCOUNT_FILTER";
